<template>
  <div>
    <header-mx></header-mx>
    <section class="main dashboard">
      <div class="figuras top">
        <div class="">
          <div
            class="row no-gutters"
            data-aos="fade-right"
            data-aos-delay="10"
            data-aos-duration="500"
          >
            <menu-lat></menu-lat>

            <div class="col-md-10 pt-4" v-if="data != null">
              <div class="headercontenido">
                <div class="col-12">
                  <span class="titulo bold">Proceso de Endoso</span>
                </div>

                <div class="col-md-12 text-left py-3">
                  <div class="card h-100 border-round p-4 shadow">
                    <div class="">
                      <div class="bold">
                        <i class="fas fa-file-alt fR"></i> Datos del
                        contratante:
                      </div>
                      <hr />
                      <div class="row fR gris2">
                        <div class="small pb-4 col-md-4">
                          <div class="bold">Número de póliza:</div>
                          <div>{{ data.no_poliza }}</div>
                        </div>
                        <div class="small pb-4 col-md-4">
                          <div class="bold">Número de certificado:</div>
                          <div>{{ data.no_certificado }}</div>
                        </div>
                        <div class="small pb-4 col-md-4">
                          <div class="bold">Inicio de Vigencia:</div>
                          <div>{{ data.vigencia_ini }}</div>
                        </div>
                        <div class="small pb-4 col-md-4">
                          <div class="bold">Fin de Vigencia:</div>
                          <div>{{ data.vigencia_fin }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 text-left pb-4">
                  <div class="card h-100 border-round p-4 shadow ">
                    <div class="">
                      <div class="bold">
                        <i class="fas fa-shield-alt fR negro"></i> Datos de Cobertura
                      </div>
                      <hr />
                      <div class="row fR gris2">
                        <div class="small pb-4 col-md-4">
                          <div class="bold">Prima Neta:</div>
                          <div>{{ data.prima_neta_txt }}</div>
                        </div>
                        <div class="small pb-4 col-md-4">
                          <div class="bold">Derecho de Póliza:</div>
                          <div>{{ data.derecho_poliza_txt }}</div>
                        </div>
                        <div class="small pb-4 col-md-4">
                          <div class="bold">IVA:</div>
                          <div>{{ data.iva_txt }}</div>
                        </div>
                        <div class="small pb-4 col-md-4">
                          <div class="bold">Prima Total:</div>
                          <div>{{ data.prima_total_txt }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 text-left pb-4 mb-4">
                    <div class="card fR h-100 border-round p-4 shadow gris2">
                      <div class="pb-5">
                        <div class="bold negro">
                          <i class="fas fa-bicycle fR"></i> Datos de la
                          bicicleta
                        </div>
                        <hr />
                        <div class="d-flex">
                          <div class=" pb-4 w-100">
                            <div class="bold">Marca:</div>
                            <div>{{ data.marca }}</div>
                          </div>
                          <div class=" pb-4 w-100">
                            <div class="bold">No. de Serie:</div>
                            <div>{{ data.no_serie }}</div>
                          </div>
                          <div class=" pb-4 w-100">
                            <div class="bold">Equipamiento Adicional:</div>
                            <div>{{ data.equipamiento_adicional }}</div>
                          </div>
                          <div class=" pb-4 w-100">
                            <div class="bold">Valor Factura:</div>
                            <div>{{ data.valor_factura_txt }}</div>
                          </div>
                          <div class=" pb-4 w-100">
                            <div class="bold">Año:</div>
                            <div>{{ data.ano }}</div>
                          </div>
                        </div>
                        <!-- <div class="d-flex">
                          <div class=" pb-4 w-100">
                            <div class="bold">Descripcion:</div>
                            <div>{{ data.descripcion }}</div>
                          </div>
                          
                        </div> -->
                      </div>
                    </div>
                  </div>

                <div class="col-12 py-3">
                  <div class="pasos">
                    <div
                      class="paso"
                      v-bind:class="{ activo: paso == 1, pasado: paso > 1 }"
                    >
                      <!-- <div class="numero">
                        <span>4</span>
                      </div> -->
                      <i class="icono fas fa-file fM"></i>
                      <div class="texto">
                        <span>Datos del endoso</span>
                      </div>
                    </div>
                    <div
                      class="paso"
                      v-bind:class="{ activo: paso == 2, pasado: paso > 2 }"
                    >
                      <!-- <div class="numero">
                        <span>5</span>
                      </div> -->
                      <i class="icono fas fa-shield-alt fM"></i>
                      <div class="texto">
                        <span>Cobertura</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="contenido">
                <form
                  class="row mx-3"
                  method="post"
                  @submit="submitFormulario($event)"
                >
                  <div
                    class="formulario col-12 bg-white shadow p-4 rounded card"
                  >
                    <div class="row" v-show="paso == 1">
                      <div class="col-12 bgblanco rounded pt-3 pb-4">
                        <div class="row">
                          <!-- <div class="col-md-12 pb-2">
                            <label>
                              <span>Valor del endoso</span>
                              <input
                                type="number"
                                v-model="form.valor_endoso"
                                maxlength="100"
                                placeholder="$"
                                
                              />
                            </label>
                          </div> -->
                          <div class="col-md-6 pb-2">
                            <label>
                              <span>Inicio de vigencia del endoso</span>
                              <input
                                type="datetime-local"
                                v-model="form.vigencia_ini"
                                maxlength="100"
                                placeholder="Clic para seleccionar"
                                :min="minDate"
                                @change="changeVigenciaIni()"
                                
                              />
                            </label>
                          </div>
                          <div class="col-md-6 pb-2">
                            <label>
                              <span>Fin de vigencia del endoso</span>
                              <input
                                type="datetime-local"
                                v-model="form.vigencia_fin"
                                maxlength="100"
                                placeholder="Clic para seleccionar"
                                readonly
                              />
                            </label>
                          </div>

                          <div class="col-md-6 pb-2">
                            <label>
                              <span>Marca</span>
                              <input
                                type="text"
                                v-model="form.marca"
                                maxlength="100"
                                placeholder="Marca"
                                readonly
                              />
                            </label>
                          </div>
                          <div class="col-md-6 pb-2">
                            <label>
                              <span>Modelo</span>
                              <input
                                type="text"
                                v-model="form.modelo"
                                maxlength="100"
                                placeholder="Modelo"
                                readonly
                              />
                            </label>
                          </div>
                          <div class="col-12 pb-2">
                            <label>
                              <span>No. de serie</span>
                              <input
                                type="text"
                                v-model="form.no_serie"
                                maxlength="100"
                                placeholder="No. de serie"
                                readonly
                              />
                            </label>
                          </div>

                          <div class="col-12 pb-2">
                            <label>
                              <span>Equipamiento Adicional</span>
                              <textarea
                                v-model="form.equipamiento_adicional"
                                class="w-100"
                                rows="4"
                                
                              ></textarea>
                            </label>
                          </div>

                          <div class="col-md-6 pb-2">
                            <label>
                              <span>Valor Factura</span>
                              <input
                                type="number"
                                v-model="form.valor_factura"
                                placeholder="$"
                                
                              />
                            </label>
                          </div>

                          <div class="col-md-6 pb-2">
                            <label>
                              <span>Año</span>
                              <input
                                type="number"
                                v-model="form.ano"
                                min="1111"
                                max="9999"
                                placeholder="Año"
                                readonly
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row resumen py-4" v-show="paso == 2">
                      <!-- <div class="col-12 pb-2 fC small">
                        Suma asegurada: ${{ form.valor_factura }}
                      </div> -->
                      <div class="col-md-4 text-center pb-4">
                        <div class="card border-round shadow">
                          <div>
                            <div>FECHA INICIO ENDOSO</div>
                            <div class="bold fR">
                              {{ form.fecha_inicio_endoso_formatted }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 text-center pb-4">
                        <div class="card border-round shadow">
                          <div>
                            <div>FECHA FIN ENDOSO</div>
                            <div class="bold fR">
                              {{ form.fecha_fin_endoso_formatted }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 text-center pb-4">
                        <div class="card border-round shadow">
                          <div>
                            <div>DIAS ENDOSO</div>
                            <div class="bold fR">
                              {{ form.diferencia_dias_vigencia }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-12 text-center pb-4">
                        <div class="card border-round shadow">
                          <div>
                            <div>VALOR FACTURA</div>
                            <div class="bold fG">${{ form.valor_factura }}</div>
                          </div>
                        </div>
                      </div>


                      <div class="col-md-4 text-center pb-4">
                        <div class="card border-round shadow">
                          <div>
                            <div>ENDOSO NETO</div>
                            <div class="bold fG">${{ form.endoso_neto }}</div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-4 text-center pb-4">
                        <div class="card border-round shadow">
                          <div>
                            <div>IVA</div>
                            <div class="bold fG">${{ form.iva }}</div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-4 text-center pb-4">
                        <div class="card border-round shadow">
                          <div>
                            <div>ENDOSO TOTAL</div>
                            <div class="bold fG">${{ form.endoso_total }}</div>
                          </div>
                        </div>
                      </div>

                      <!-- <div class="col-12 text-center pb-4">
                        <div class="card border-round">
                          <div>
                            <div>PRIMA TOTAL</div>
                            <div class="bold fG">${{ form.prima_total }}</div>
                          </div>
                        </div>
                      </div> -->
                    </div>

                    <div class="row">
                      <div class="col-12">
                        <div
                          class="text-center pt-2 float-left"
                          v-show="paso > 1"
                        >
                          <button
                            type="button"
                            class="submit btnnaranja"
                            @click="regresar()"
                          >
                            REGRESAR
                          </button>
                        </div>
                        <div
                          class="text-center pt-2 float-right"
                          v-show="paso < 2"
                        >
                          <button
                            type="button"
                            class="submit btnnaranja"
                            @click="continuar()"
                          >
                            CONTINUAR
                          </button>
                        </div>
                        <div
                          class="text-center pt-2 float-right"
                          v-show="paso == 2"
                        >
                          <button type="submit" class="submit btnnaranja">
                            FINALIZAR
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <span class="loading" v-bind:class="{ active: this.$store.state.loading }">
      <img src="../assets/imgs/DualRing-1.1s-28px.svg" alt="loading" />
    </span>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../Components/Header.vue";
import Menu from "../Components/Menu.vue";
import { ServerTable, ClientTable, Event } from "vue-tables-2";

import moment from "moment";

import Vue from "vue";
Vue.use(ClientTable);

export default {
  name: "GAIG",
  props: {
    msg: String,
  },
  data() {
    return {
      minDate: null,
      paso: 1,
      form: {
        contratante: "",
        no_poliza: "",
        no_certificado: "",
        vigencia_ini: "",
        vigencia_fin: "",
        usar_razon_social: false,
        razon_social: "",
        nombre: "",
        apellido_paterno: "",
        apellido_materno: "",
        rfc: "",
        email: "",
        email2: "",
        telefono: "",
        ciudad: "",
        municipio_o_del: "",
        colonia: "",
        cp: "",
        calle: "",
        no_ext: "",
        no_int: "",
        marca: "",
        modelo: "",
        no_serie: "",
        equipamiento_adicional: "",
        valor_factura: "",
        ano: "",
        prima_neta: "",
        derecho_de_poliza: "",
        iva: "",
        prima_total: "",
        cobertura_basica: "",
        robo_con_violencia: "",
        responsabilidad_civil: "",
        valor_endoso: "",
        endoso_total: "",
        endoso_neto: "",
        diferencia_dias_vigencia: "",
        fecha_inicio_endoso: "",
        fecha_inicio_endoso_formatted: "",
        fecha_fin_endoso_formatted: "",
        valor_bicicleta: ""
      },
      tiposervicio: "",
      columns: [
        "nombre",
        "email",
        "no_poliza",
        "no_certificado",
        "uri",
        // "baja",
        // "bloqueo"
      ],
      datos: null,
      data: null,
      options: {
        perPage: 5,
        perPageValues: [5, 10, 15, 25, 50, 100],
        headings: {
          matricula: "Matrícula",
          nombre: "Nombre",
          email: "Email",
          no_poliza: "No. de póliza",
          no_certificado: "No. de certificado",
          uri: "Detalle",
          baja: "Baja",
          bloqueo: "Bloqueo",
        },
        editableColumns: ["name"],
        sortable: [],
        pagination: {
          show: true,
          dropdown: false,
          chunk: 10,
          edge: true,
          align: "center",
          nav: "fixed",
        },
        texts: {
          count:
            "Mostrando desde {from} hasta {to} - {count} registros|{count} registros|Un registro",
          first: "Primera",
          last: "Última",
          filter: "",
          filterPlaceholder: "Buscar registro",
          limit: "",
          page: "Página:",
          noResults: "No se encontraron resultados.",
          filterBy: "Filtrando por {column}",
          loading: "Cargando...",
          defaultOption: "Seleccionar {column}",
          columns: "Columnas",
        },
      },
    };
  },
  components: {
    "header-mx": Header,
    "menu-lat": Menu,
  },
  mounted: function () {
    this.$store.state.user = JSON.parse(this.$cookie.get("usergaig"));

    moment.locale('es'); 


    AOS.init();

    this.id_registro = this.$route.params.id;

    this.consulta();
  },
  methods: {
    consulta() {
      console.log("consulta");
      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        id: this.id_registro,
        admin_id: this.$store.state.user.admin_id,
        user_id: this.$store.state.user.id
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "consulta-registro.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.data = res.datos[0];

              this.form.contratante = this.data.contratante;
              this.form.vigencia_ini = this.initVigenciaIni();

              this.minDate = new Date(this.form.vigencia_ini);
              this.minDate.setDate(this.minDate.getDate()-1);
              this.minDate.setUTCHours(0,0,0,0);
              this.minDate = this.minDate.toISOString();
              this.minDate = this.minDate.substring(0,this.minDate.length-1);



              this.form.vigencia_fin = this.data.vigencia_fin
                .toString()
                .replace(" ", "T");

              this.form.usar_razon_social = this.data.usar_razon_social;
              this.form.razon_social = this.data.razon_social;
              this.form.nombre = this.data.nombre;
              this.form.apellido_paterno = this.data.apellido_paterno;
              this.form.apellido_materno = this.data.apellido_materno;
              this.form.rfc = this.data.rfc;
              this.form.email = this.data.email;
              this.form.email2 = this.data.email;
              this.form.telefono = this.data.telefono;
              this.form.ciudad = this.data.ciudad;
              this.form.municipio_o_del = this.data.municipio_o_del;
              this.form.colonia = this.data.colonia;
              this.form.cp = this.data.cp;
              this.form.calle = this.data.calle;
              this.form.no_ext = this.data.no_ext;
              this.form.no_int = this.data.no_int;
              this.form.marca = this.data.marca;
              this.form.modelo = this.data.modelo;
              this.form.no_serie = this.data.no_serie;
              //this.form.equipamiento_adicional = this.data.equipamiento_adicional;
              this.form.valor_bicicleta = this.data.valor_factura;
              this.form.ano = this.data.ano;
              this.form.prima_neta = this.data.prima_neta;
              this.form.derecho_de_poliza = this.data.derecho_poliza;
              this.form.iva = this.data.iva;
              this.form.prima_total = this.data.prima_total;
              this.form.cobertura_basica = this.data.cobertura_basica;
              this.form.robo_con_violencia = this.data.robo_con_violencia;
              this.form.responsabilidad_civil - this.data.i;
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    razonSocialChange(e) {
      if (!this.form.usar_razon_social) {
        this.form.razon_social = "";
      } else {
        this.form.rfc = "";
        this.form.nombre = "";
        this.form.apellido_paterno = "";
        this.form.apellido_materno = "";
      }
    },
    continuar() {
      if (this.paso == 1 && this.form.valor_factura == "" && this.form.equipamiento_adicional == "") {
        swal.fire(
          "Oops",
          "Captura todos los campos antes de continuar...",
          "warning"
        );
        return;
      }

      this.paso++;

      if (this.paso == 2) {
        //calcular endoso

        let valor_factura = this.form.valor_factura;
        let prima = this.form.prima_total;


        let date = new Date(this.form.vigencia_ini);
        this.form.fecha_inicio_endoso =
          this.formatDate(date) + "T" + this.formatTime(date);
        console.log({ fecha_inicio_endoso: this.form.fecha_inicio_endoso });

        this.form.diferencia_dias_vigencia = moment(
          this.form.vigencia_fin
        ).diff(moment(this.form.fecha_inicio_endoso).add(-1, "day"), "days");
        console.log({ diferencia_dias: this.form.diferencia_dias_vigencia });

        this.form.fecha_inicio_endoso_formatted = moment(
          this.form.fecha_inicio_endoso
        ).format("llll");
        this.form.fecha_fin_endoso_formatted = moment(
          this.form.vigencia_fin
        ).format("llll");


        this.form.endoso_neto = parseFloat(this.form.prima_neta) / parseFloat(this.form.valor_bicicleta);
        this.form.endoso_neto =  parseFloat(this.form.endoso_neto) * parseFloat(this.form.valor_factura);
        this.form.endoso_neto =  parseFloat(this.form.endoso_neto) / 365 * parseFloat(this.form.diferencia_dias_vigencia);
        
        
        this.form.iva =  parseFloat(parseFloat(this.form.endoso_neto) * 0.16);
        this.form.endoso_total = parseFloat(this.form.endoso_neto) + parseFloat(this.form.iva);

        this.form.endoso_neto = this.form.endoso_neto.toFixed(2);
        this.form.iva = this.form.iva.toFixed(2);
        this.form.endoso_total = this.form.endoso_total.toFixed(2);

        // this.form.endoso_neto = parseFloat(
        //   (this.form.diferencia_dias_vigencia * this.form.prima_total) / 365
        // ).toFixed(2);

        console.log(this.form.endoso_neto);
        console.log(this.form.endoso_total);
      }
    },
    regresar() {
      this.paso--;
    },
    submitFormulario(e) {
      console.log("enviando");
      //terminar
      e.preventDefault();

      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        id_registros: this.id_registro,
        no_certificado: this.data.no_certificado,
        valor_factura: this.form.valor_factura,
        endoso: this.form.endoso_total,
        endoso_neto: this.form.endoso_neto,
        iva: this.form.iva,
        fecha_ini_endoso: this.form.fecha_inicio_endoso,
        fecha_fin_endoso: this.form.vigencia_fin,
        dias_endoso: this.form.diferencia_dias_vigencia,
        equipamiento_adicional: this.form.equipamiento_adicional
      };
      qData.admin_id = this.$store.state.user.admin_id;

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log(JSON.stringify(qData));

      this.$http
        .post(vm.$store.state.baseurl + "alta-endoso.php", formData, {
          emulateJSON: true,
          httpsAgent: new https.Agent({ rejectUnauthorized: false }),
          headers: {
            "Content-Type": "multipart/form-data",
            //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
          },
        })
        .then(
          (response) => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.$router.push("/registro/" + this.id_registro);
              
              // swal
              //   .fire({
              //     title: "Endoso",
              //     html: res.msg,
              //     confirmButtonText: `Ok`,
              //     icon: "success",
              //   })
              //   .then((result) => {
              //     /* Read more about isConfirmed, isDenied below */
              //     if (result.isConfirmed) {
              //       this.$router.push("/registro/" + this.id_registro);
              //     }
              //   });
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    changeVigenciaIni() {
      console.log(this.form.vigencia_ini);
      let date = new Date(this.form.vigencia_ini);
      

      let hoy =  new Date();
      if(moment(hoy).isAfter(date, 'day')){
        swal.fire('Oops', 'Fecha inválida.', 'warning');
        return;
      }


      //this.form.vigencia_ini = this.formatDate(date) + "T12:00";
      this.form.vigencia_ini = this.formatDate(date) + "T" + this.formatTime(date);
      
    },
    initVigenciaIni() {
      let date = new Date();
      return this.formatDate(date) + "T" + this.formatTime(date);
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    formatTime(date) {
      var d = new Date(date),
        hour = "" + d.getHours(),
        minute = "" + d.getMinutes();

      if (hour.length < 2) hour = "0" + hour;
      if (minute.length < 2) minute = "0" + minute;

      return [hour, minute].join(":");
    },
  },
};
</script>

